define('customPlugins/atnFastObservableArray',['knockout', 'lodash'],
    function(ko, _) {
        'use strict';
        ko.atnFastObservableArray = function(array, generateKeyFn) {
            var initValues = getInitial(array, generateKeyFn),
                map = initValues.map,
                observableArray = initValues.observableArray;

            observableArray.transaction = function(callback) {
                var underlyingArray = observableArray();
                callback.apply(underlyingArray, [underlyingArray]);
                observableArray.valueHasMutated();
            };

            observableArray.getByKey = function(key) {
                return map[key];
            };

            observableArray.subscribe(function(newValue) {
                map = createAssociativeArray(newValue, observableArray.keyFn);
            });

            return observableArray;
        };
        return;

        function getInitial(initialArray, generateKeyFn) {
            var array = _.isArray(initialArray) ? initialArray: [],
                keyFn = _.isFunction(generateKeyFn) ? generateKeyFn : customKeyFn,
                map = createAssociativeArray(array, keyFn),
                observableArray = ko.observableArray(array);

            observableArray.keyFn = keyFn;
            return {
                map: map,
                observableArray: observableArray
            };
        }

        function createAssociativeArray(plainArray, keyFn) {
            var map = {};
            _.each(plainArray, function(item) {
                map[keyFn(item)] = item;
            });
            return map;
        }

        function customKeyFn(item) {
            return item.id;
        }
    });
